import { assetManifest } from "../assets/manifest";

export function createUiShell(hud: HTMLElement, arena: HTMLElement): HTMLElement {
  const shell = document.createElement("main");
  shell.className = "of-app-shell";
  shell.setAttribute("aria-label", "Orbit game frame");

  const frame = document.createElement("section");
  frame.className = "of-game-frame";
  frame.setAttribute("aria-label", "Fixed 1920 by 1080 game UI");
  frame.style.setProperty(
    "--of-reactor-floor-image",
    `url("${assetManifest.reactorFloorFoundation.url}")`
  );
  frame.style.setProperty(
    "--of-rail-button-frame-image",
    `url("${assetManifest.railButtonFrame.url}")`
  );
  frame.style.setProperty(
    "--of-top-hud-chip-frame-image",
    `url("${assetManifest.topHudChipFrame.url}")`
  );
  frame.style.setProperty(
    "--of-utility-icon-frame-image",
    `url("${assetManifest.utilityIconFrame.url}")`
  );
  frame.style.setProperty(
    "--of-collector-tray-frame-image",
    `url("${assetManifest.collectorTrayFrame.url}")`
  );
  frame.style.setProperty(
    "--of-forge-panel-frame-image",
    `url("${assetManifest.forgePanelFrame.url}")`
  );

  frame.append(hud, arena);
  shell.append(frame);

  return shell;
}
